import type { AnswerMark, FiftyFiftyAnimation, PublicQuestion } from "@quizshow/protocol";
import { answerPresentationClasses } from "../question-presentation";

export function ParticipantAnswerOptions({
  answers,
  interactive,
  selectedOptions,
  hiddenOptionIds,
  answerMarks,
  solutionOptionIds,
  fiftyFiftyAnimation,
  fiftyFiftyComplete,
  onSelect,
}: {
  answers: PublicQuestion["answers"];
  interactive: boolean;
  selectedOptions: string[];
  hiddenOptionIds: string[];
  answerMarks: AnswerMark[];
  solutionOptionIds: string[];
  fiftyFiftyAnimation?: FiftyFiftyAnimation;
  fiftyFiftyComplete: boolean;
  onSelect: (optionId: string) => void;
}) {
  return (
    <div
      className={`answer-grid answer-grid--participant ${
        interactive ? "" : "answer-grid--readonly"
      }`}
      data-answer-mode={interactive ? "interactive" : "readonly"}
    >
      {answers.map((answer) => {
        const eliminated = hiddenOptionIds.includes(answer.optionId);
        const classes = `${interactive ? "answer-card--button" : "answer-card--readonly"} ${
          selectedOptions.includes(answer.optionId) ? "is-selected" : ""
        } ${answerPresentationClasses(
          answer.optionId,
          hiddenOptionIds,
          answerMarks,
          solutionOptionIds,
          fiftyFiftyAnimation,
          fiftyFiftyComplete,
        )}`;
        return interactive ? (
          <button
            className={`answer-card ${classes}`}
            disabled={eliminated}
            aria-pressed={selectedOptions.includes(answer.optionId)}
            key={answer.optionId}
            onClick={() => onSelect(answer.optionId)}
          >
            {answer.text}
          </button>
        ) : (
          <div
            className={`answer-card ${classes}`}
            aria-disabled="true"
            key={answer.optionId}
          >
            {answer.text}
          </div>
        );
      })}
    </div>
  );
}
